import {tagToggle} from '../../components/tag-toggle'

const init = () => {
    tagToggle()
}

export default init
